// extracted by mini-css-extract-plugin
export default {"DynamicMap":"iCSnM","patchDesktopMapBorders":"VIvf7","error":"V11xK"};